// This function does not use the router because it will cause circular dependencies
export default function isScreenshot() {
  if (typeof window === 'undefined') {
    return false;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const kind = urlParams.get('kind');

  if (!token || !kind) {
    return false;
  }

  return kind === 'screenshot';
}
